'use client';

import { ResourceArgsFilter } from '@app-types/blackroom-api';
import { ResourceScope } from '@app-types/blackroom-app';

/**
 * Generates resource fetching filter arugment based on resource route scope
 */
export const getResourceFilterFromScope = (
  scope?: ResourceScope,
): Omit<ResourceArgsFilter, 'workspaceId'> => {
  // Determines fetch filter depending on route scope
  let isArchived: boolean | undefined = false;
  let isRecent: boolean | undefined = false;
  let isRedacted: boolean | null = null; // Indiscrimante in regards with redaction by default
  let isFavorite: boolean | undefined;
  switch (scope ?? 'my') {
    case 'archived':
      isArchived = true;
      break;
    case 'favorites':
      isFavorite = true;
      break;
    case 'recent':
      isRecent = true;
      break;
    case 'redacted':
      isRedacted = true;
      break;
    default:
      break;
  }
  return {
    isArchived,
    isRecent,
    isFavorite,
    isRedacted,
  };
};

// export function useResourcesCacheHandlers() {
//   /* ********************************** HOOKS ********************************* */

//   // Context
//   const workspace = useWorkspace();

//   // Routing
//   const { scope = 'my', folderId: parentId = null } = useParams<{
//     scope: ResourceScope;
//     folderId?: string;
//   }>();

//   /* ******************************** HANDLERS ******************************** */

//   const addResourcesToScopeCache = ({
//     cache,
//     workspace,
//     scope,
//     resource,
//     parentId,
//     sorter,
//   }: {
//     cache: ApolloCache<any>;
//     scope: ResourceScope;
//     resources: Resource[];
//     parentId?: string;
//     sorter?: ResourceArgsSorter;
//   }) =>
//     cache.modify({
//       fields: {
//         resources(getResourcesExistingRefs, { readField }) {
//           const existingResourceRefs = getResourcesExistingRefs?.nodes ?? [];

//           const currentCachedQueryData = cache.readQuery<GetResourcesQuery>({
//             query: GET_RESOURCES,
//             variables: {
//               filter: {
//                 ...getResourceFilterFromScope('my'),
//                 workspaceId: workspace.id,
//                 parentId,
//               },
//               sorter: sorter ?? {
//                 createdAt: SortDirection.Desc,
//               },
//               limit: CACHE_BLOCK_SIZE,
//               offset: 0,
//             } as GetResourcesQueryVariables,
//           });

//           const queryResourceRefs = existingResourceRefs.filter((ref: any) =>
//             currentCachedQueryData?.resources.nodes?.some((n) => n.id === readField('id', ref))
//           );

//           const resourcesToRestoreRefs = resources.map((r) => {
//             const newResourceData = r;
//             return cache.writeFragment({
//               data: newResourceData,
//               fragment: NEW_RESOURCE_FRAGMENT,
//             });
//           });

//           return {
//             ...getResourcesExistingRefs,
//             pageInfo: {
//               ...queryResourceRefs.pageInfo,
//               totalCount: queryResourceRefs.length + 1,
//             },
//             nodes: [...resourcesToRestoreRefs, ...(queryResourceRefs?.nodes ?? [])],
//           };
//         },
//       },
//     });
// }
